import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import {
  FlashFavoriteCheck,
  SetFlashFavorite,
  getCategory,
  getProducts,
  getSubCategory,
  mediaBaseUrl,
} from "../axios";
import ProductOne from "../components/product/productOne";
import { Link, useLocation, useParams } from "react-router-dom";
import Flash from "./Flash";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../components/shared/context/cart-context";
import { FavoriteBoxIcon, TimesIcon } from "../assets/Icons/index";
import { separate } from "../tools/helper";
import { ExistDataContext } from "../components/shared/context/dataExist-context";
import { ShoppingContext } from "../components/shared/context/shopping-context";
import { AddFavoriteIcon } from "./Flash";
import { useAppSelector } from "../store/configureStore";
import roundToNearestFiveThousand from "../tools/roundToNearestFiveThousand";
import { checkImageFormat } from "../tools/mediaUrlHelper";

const Shop = () => {
  const { user } = useAppSelector((state) => state.account);

  const {
    productsBySubCategory,
    setProductsBySubCategory,
    flashId,
    setFlashId,
    subCategory,
    setSubCategory,
    activeFlash,
    setActiveFlash,
    flashCartModal,
    setFlashCartModal,
    classes,
    setClasses,
    setStyles,
    selectTypeCategory,
    setSelectTypeCategory,
    callNewCategories,
  } = useContext(ShoppingContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [products, setProducts] = useState();
  const [category, setCategory] = useState();
  const [cartItems, setCartItems] = useContext(CartContext);
  const [existProduct, existsInArray] = useContext(ExistDataContext);
  const [categoryLoading, setCategoryLoading] = useState(true);
  const [checkPaymentedFlashCart, setCheckPaymentedFlashCart] = useState(false);

  const [totalFlashCart, setTotalFlashCart] = useState({
    name: "",
    price: 0,
    number: 0,
    id: null,
  });

  // console.log("products is", existProduct);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const maghta = searchParams.get("maghta");
    getCategory().then(({ data }) => {
      const filteredData = data.filter(
        (item) => item.id !== 8 && item.id !== 10
      ); //delete azmoon category
      if(filteredData)setCategory(filteredData)
    });
  }, [location.search]);

  const paymentedCheck = (array, id) => {
    return array.some((item) => item.productSubCategoryID == id);
  };

  //first we get current category and subcategory id from params

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const currentCategoryId = searchParams.get("catId");
    const currentSubCategoryId = searchParams.get("subCatId");
    if (currentCategoryId == 4) {
      setFlashId(4);
      modalVisibleOrInvisible();
    }
    setSelectTypeCategory(currentCategoryId);
    setCategoryLoading(true);
    setFlashCartModal(false);
    //first we check for existance of subCategoryId, if it wasnt there we show products based on categoryId
    if (currentSubCategoryId) {
      setActiveFlash(currentSubCategoryId);
      setCategoryLoading(true);
      getProducts().then(({ data }) => {
        setProducts(data);
        const filteredBySubCategory = data.filter(
          (item) => currentSubCategoryId == item.subCategoryID
        );
        setProductsBySubCategory(filteredBySubCategory);
      });

      //getting subcategories base on category id
      getSubCategory(currentCategoryId).then(({ data }) => {
        setSubCategory(data);
        setCategoryLoading(false);
      });
    } else if (currentCategoryId) {
      getProducts().then(({ data }) => {
        setProducts(data);
        const filterProducts = data?.filter(
          (p) => p.categoryID == currentCategoryId
        );
        if (filterProducts) {
          filterProducts.sort(function (a, b) {
            if (a.currentCategoryId < b.currentCategoryId) {
              return -1;
            }
            if (a.currentCategoryId > b.currentCategoryId) {
              return 1;
            }
            // sub category must be equal
            return 0;
          });
        }

        setProductsBySubCategory(filterProducts);
      });
      getSubCategory(currentCategoryId).then(({ data }) => {
        setSubCategory(data);
        setCategoryLoading(false);
      });
    }
  }, [location.search]);

  const callNewProducts = (subCategoryId) => {
    const paymentedFlashCart = paymentedCheck(existProduct, subCategoryId);
    setCheckPaymentedFlashCart(paymentedFlashCart);
    const filterProducts = products?.filter(
      (p) => p.subCategoryID == subCategoryId
    );
    setProductsBySubCategory(filterProducts);
    setTimeout(() => {
      setCategoryLoading(false);
    }, 500);
  };

  function modalVisibleOrInvisible() {
    if (classes === "modal fade") {
      setClasses("modal fade show");
      setStyles("block");
    } else {
      setClasses("modal fade");
      setStyles("none");
    }
  }

  //checking if current user has already purchased all of products of an specefic subCategory
  //so if he has all of them dont let him to buy again for online products
  const existsInTheArray = (purchasedProducts, value) => {
    if (products && purchasedProducts && value) {
      const allProducts = [...products];
      const allFilteredBySubId = allProducts.filter(
        (item) => item.subCategoryID == value.id
      );
      const purchasedFilteredBySubId = purchasedProducts.filter(
        (item) => item.productSubCategoryID == value.id
      );

      const allIds = allFilteredBySubId?.filter(item => item.isAsli).map((item) => item.id);
      const purchasedIds = purchasedFilteredBySubId?.map(
        (item) => item.productID
      );
      
      const allProductsPurchased = allIds.every((id) =>
        purchasedIds.includes(id)
      );

      return {
        allProductsPurchased,
        purchasedIds,
      };
    }
  };

  const existsInArraySecond = (array, id) => {
    return array.some((item) => item.id === id);
  };

  const addToSabadKharidHandler = (e, value) => {
    // console.log("value is ", value);
    e.preventDefault();
    //we get ids of purchased products so to filter and then add to basket
    //and we get a boolean based on all the products of an subCategory are already purchased or not
    //we use these two only for online products
    const { allProductsPurchased, purchasedIds } = existsInTheArray(
      existProduct,
      value
    );
    if (allProductsPurchased === false || allProductsPurchased === undefined) {
      if (user) {
        // const flashCartExists = cartItems.some((item) => item.categoryID === 4);
        // if (flashCartExists && value.categoryID === 4)
        //   return toast.error(
        //     "امکان خرید همزمان چند نوع فلش کارت فراهم نمیباشد"
        //   );
        let existProductAdd = existsInArraySecond(cartItems, value.id);
        let array = [...cartItems];
        // console.log("all proooooo" , products);
        
        const filteredList = products.filter(
          (item) => item.subCategoryID == value.id && item.isAsli === true
        );
        // console.log("filter proooooo" , filteredList);

        const updatedFilteredList = filteredList.filter(
          (item) => !purchasedIds.includes(item.id)
        );
        // console.log("updated proooooo" , updatedFilteredList);

        if (flashId == 4 || value.categoryID === 4) {
          setTotalFlashCart({
            name: value.subCategoryTitle,
            price: filteredList.length * filteredList[0]?.priceTakhfif,
            number: filteredList.length,
            id: value.id,
          });
          setFlashCartModal(true);
        } else {
          if (existProductAdd == true && value.categoryID == 1) {
            try {
              filteredList.map((item) => {
                array.push(item);
              });
              setCartItems(array);
              toast.success("به سبد خرید اضافه شد");
            } catch (error) {
              console.log(error.message);
            }
          } else if (existProductAdd == false && value.categoryID != 1) {
            try {
              updatedFilteredList.map((item) => {
                array.push(item);
              });
              setCartItems(array);
              toast.success("به سبد خرید اضافه شد");
            } catch (error) {
              console.log(error.message);
            }
          } else if (existProductAdd == true && value.categoryID != 1) {
            toast.error(
              "کاربر گرامی محصول مورد نظر را قبلا به سبد خرید اضافه کرده اید"
            );
          } else {
            try {
              updatedFilteredList.map((item) => {
                array.push(item);
              });
              setCartItems(array);
              toast.success("به سبد خرید اضافه شد");
            } catch (error) {
              console.log(error.message);
            }
          }
        }
      } else {
        toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
      }
    } else {
      return toast.error("این محصول قبلا خریداری شده است.");
    }
  };

  const addToShoppingCartFlash = (e, id) => {
    e.preventDefault();
    // console.log("total flash name", totalFlashCart);
    if (localStorage.getItem("login")) {
      let array = [...cartItems];
      const existData = array.some((I) => I.id === id);
      if (existData) {
        return toast.error(
          "کاربر گرامی محصول مورد نظر را قبلا به سبد خرید اضافه کرده اید"
        );
      } else {
        const filteredList = products.filter(
          (item) =>
            item?.subCategoryTitle?.trim() == totalFlashCart?.name?.trim() && item.isAsli
        );
        try {
          filteredList.map((item) => {
            array.push(item);
          });
          setCartItems(array);
          setFlashCartModal(false);
          toast.success("به سبد خرید اضافه شد");
        } catch (error) {
          console.log(error.message);
        }
      }
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  // ---------------------------------------- React Scroll
  const [searchIndex, setSearchIndex] = useState(0);

  const handleSearch = () => {
    if (searchIndex > 0 && searchIndex < productsBySubCategory.length) {
      const item = productsBySubCategory[searchIndex];

      // Use window.scroll and animate to smoothly scroll to the matching element
      const element = document.getElementById(item.id);

      if (element) {
        const top = element.getBoundingClientRect().top + window.scrollY;
        // const top = element.getBoundingClientRect().top + window.pageYOffset;
        const duration = 1000;
        window.scroll({
          top,
          behavior: "smooth",
          duration,
        });
      }
    }
  };

  // ------------------------------------------- Modal Flash carts

  // -------------------------------------- Modal Flash Showing Handler
  const [showFlash, setShowFlash] = useState(false);
  const [changeImg, setChangeImg] = useState(1);
  const [modalImage, setModalImage] = useState({
    img: "",
    fileasli: "",
    description: "",
    id: "",
    catId: "",
  });
  const [loading, setloading] = useState(true);

  const modalFlashShowingHandler = (e, id) => {
    e.preventDefault();
    setShowFlash(true);
    setChangeImg(id);
  };

  // const checkImageFormat = (fileasli) => {
  //   const formats = ["jpg", "png"];
  //   return Promise.any(
  //     formats.map((ext) =>
  //       fetch(`${mediaBaseUrl}${fileasli}.${ext}`, { method: "HEAD" }).then(
  //         (res) => (res.ok ? ext : Promise.reject())
  //       )
  //     )
  //   );
  // };

  useEffect(() => {
    // Clone the array just like before
    Object.assign([], productsBySubCategory).forEach(async (item, index) => {
      // same conditions as before
      if (
        flashId == 4 &&
        index == changeImg &&
        index < productsBySubCategory.length
      ) {
        try {
          const result = await checkImageFormat(item?.fileasli);
  
          if (result) {
            const { format, baseUrl } = result; // destructure both values
  
            setModalImage({
              description: item.description,
              img: item.filedemo,
              // use the correct base URL (with fallback if needed)
              fileasli: `${baseUrl}${item?.fileasli}.${format}`,
              id: item.id,
              catId: item.subCategoryID,
            });
          } else {
            console.error("No valid format found for:", item?.fileasli);
          }
        } catch (error) {
          console.error("Error while checking image format:", error);
        }
      }
    });
  }, [productsBySubCategory, changeImg]);
  

  const [rotateState, setRotateState] = useState({
    status: false,
    value: "flipped",
  });

  const clickShowBackProduct = (value) => {
    if (value === true) {
      setRotateState({ status: true, value: "flipped" });
    } else {
      setRotateState({ status: false, value: "" });
    }
  };

  const addToFavorite = (e, id, categoryID) => {
    e.preventDefault();

    if (localStorage.getItem("login")) {
      FlashFavoriteCheck(localStorage.getItem("phonenumber"), id).then(
        ({ data }) => {
          if (data === "0") {
            SetFlashFavorite(
              localStorage.getItem("phonenumber"),
              id,
              categoryID
            ).then((response) => {
              if (response.data === "1") {
                toast.success("به جعبه من اضافه شد");
              } else {
                toast.error("عملیات ادد با خطا مواجه شد.");
              }
            });
          } else {
            toast.error("قبلا به جعبه من اضافه شده است!");
          }
        }
      );
    } else {
      toast.error("لطفا ابتدا از بخش منو بالا وارد حساب کاربری خود شوید");
    }
  };

  //check if the user has already purchased a whole subcategory flash cards so we dont show the add to basket in subcategories section
  const isUserPurchasedFlashCards = (value) => {
    if (products && existProduct) {
      if (value?.categoryID == 4) {
        return existProduct?.some(
          (item) =>
            item.productCategoryID === value.categoryID &&
            item.productSubCategoryID === value.id
        );
      } else if (
        (existProduct && value?.categoryID == 3) ||
        value?.categoryID == 2
      ) {
        const { allProductsPurchased } = existsInTheArray(existProduct, value);
        if (allProductsPurchased) return allProductsPurchased;
      } else return false;
    }
  };

  //chekcing subCategory prices
  const checkSubCategoryPrices = (value) => {
    if (existProduct && products) {
      const filteredList = products?.filter(
        (item) => item.subCategoryID == value.id
      );
      const Price = filteredList?.reduce((accumulator, currentValue) => {
        return Number(accumulator) + Number(currentValue.price);
      }, 0);

      const PriceTakhfif = filteredList?.reduce((accumulator, currentValue) => {
        return Number(accumulator) + Number(currentValue.priceTakhfif);
      }, 0);

      // Round totalPrice and totalPriceTakhfif to the next bigger multiple of 5000
      const totalPrice = roundToNearestFiveThousand(Price);
      const totalPriceTakhfif = roundToNearestFiveThousand(PriceTakhfif);

      return { totalPrice, totalPriceTakhfif, filteredList };
    }
  };

  //preventing user from downloading flash cart images
  document.addEventListener("contextmenu", (e) => {
    if (e.target.tagName === "IMG") {
      e.preventDefault();
    }
  });

  const { pathname } = useLocation();
  // console.log("modalImage", modalImage);

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);
  return (
    <React.Fragment>
      {/* ---------------------------------------- Start Modal Flash Showing Handler ------------------- */}
      {showFlash && (
        <div
          className="modal fade show"
          role="dialog"
          style={{
            display: `${showFlash ? "block" : "hidden"}`,
            backgroundColor: "rgba(0,0,0,0.6)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              className="modal-content rounded mx-auto col-11 col-sm-8"
              style={{
                overflowY: "scroll",
                maxHeight: "90vh",
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title">فلش کارت</h5>
                <button
                  type="button"
                  className="close m-1 text-center"
                  onClick={() => {
                    setShowFlash(false);
                    setRotateState({ status: false, value: "" });
                    // setChangeImg(1);
                  }}
                >
                  <TimesIcon />
                </button>
              </div>
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px 0",
                  }}
                >
                  <button
                    // style={{ color: "white", marginRight: "15px" }}
                    onClick={(e) =>
                      addToFavorite(e, modalImage.id, modalImage.catId)
                    }
                    title="افزودن به جعبه من "
                    className="btn btn-primary btn-sm rounded-circle"
                  >
                    <AddFavoriteIcon />
                  </button>
                  <span>
                    {changeImg}/{productsBySubCategory.length - 1}
                  </span>
                </div>
                <div
                  className="border rounded shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    minHeight: "50vh",
                  }}
                >
                  {loading ? (
                    <div class="loader-6 centerLoader">
                      <span></span>
                    </div>
                  ) : null}
                  <img
                    src={
                      rotateState.status
                        ? modalImage?.fileasli
                        : modalImage?.img
                    }
                    alt="Product_image"
                    style={loading ? { display: "none" } : {}}
                    onLoad={() => setloading(false)}
                  />
                </div>
                <div
                  className="py-2 mx-auto"
                  style={{ width: "200px", marginTop: "20px" }}
                >
                  <button
                    onClick={() => {
                      clickShowBackProduct(!rotateState.status);
                      setloading(true);
                    }}
                    className="flip btn btn-primary mt-2 w-100"
                  >
                    برگرداندن کارت
                  </button>
                  <div className=" d-flex align-items-center justify-content-between mt-4 mb-2 ">
                    <button
                      onClick={() => {
                        setChangeImg((prevState) => prevState - 1);
                        setloading(true);
                        setRotateState({ status: false, value: "" });
                      }}
                      disabled={changeImg <= 0}
                      className="btn btn-primary"
                    >
                      قبلی
                    </button>
                    <button
                      onClick={() => {
                        setChangeImg((prevState) => prevState + 1);
                        setloading(true);
                        setRotateState({ status: false, value: "" });
                      }}
                      className="btn btn-primary"
                      disabled={
                        checkPaymentedFlashCart &&
                        changeImg < productsBySubCategory.length - 1
                          ? false
                          : !!(changeImg >= 5)
                      }
                    >
                      بعدی
                    </button>
                  </div>
                </div>
              </div>
              <p
                className="modal-footer mr-auto"
                style={{ textAlign: "justify", marginBottom: "20px" }}
              >
                <span
                  className="text-primary"
                  style={{ fontSize: "16px", fontWeight: "600" }}
                >
                  توضیحات:
                </span>
                {modalImage.description}
              </p>
            </div>
          </div>
        </div>
      )}
      {/* // -------------------------------------------------------- End Modal Flash Showing Handler ------------------- */}
      {/* ---------------------------------------- Start Modal دسته بندی ------------------- */}
      {flashCartModal && (
        <div
          className="modal fade show"
          role="dialog"
          style={{
            display: `${flashCartModal ? "block" : "hidden"}`,
            backgroundColor: "rgba(0,0,0,0.6)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content rounded mx-auto col-11 col-sm-8 col-md-6 col-lg-4">
              <div className="modal-header">
                <button
                  type="button"
                  className="close m-1 text-center"
                  onClick={() => setFlashCartModal(false)}
                >
                  <TimesIcon />
                </button>
                <h5 className="modal-title">مشخصات محصول</h5>
              </div>
              <div className="modal-body" style={{ minHeight: "150px" }}>
                <p>نام محصول : {totalFlashCart.name}</p>
                <p>
                  قیمت:{" "}
                  {separate(roundToNearestFiveThousand(totalFlashCart.price))}{" "}
                  تومان
                </p>
                <p>تعداد: {totalFlashCart.number}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={() => setFlashCartModal(false)}
                >
                  انصراف
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={(e) => addToShoppingCartFlash(e, totalFlashCart.id)}
                >
                  افزودن به سبد خرید
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* // -------------------------------------------------------- End Modal */}
      <div className="breadcrumbs_area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb_content">
                <ul>
                  <li>
                    <Link to="/">خانه</Link>
                  </li>

                  <li>فروشگاه</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="shop_area shop_reverse mt-60 mb-60">
        <div className="container-fluid ps-3 pe-5">
          {/* -----------------------------------  INPUT SEARCH ------------------------------------------- */}
          {flashId == 4 && (
            <div className="row mb-2">
              <div className="col-12 flashCard-header-text mb-5">
                <p>
                  <span>فلش‌کارت‌های آتروپین</span> بهترین گزینه برای مرور در
                  کوتاه‌ترین زمان ممکن برای هر امتحانی هستند{" "}
                  <span>اما بدونید</span> که اگر تابحال درسی رو نخوندید خوندن
                  فلش‌کارت‌ها رو خیلی بهتون توصیه نمی‌کنیم. بعد از تهیه،{" "}
                  <span>از همین صفحه</span> به فلش‌کارت‌ها دسترسی دارید، برخلاف
                  مابقی محصولات دیجیتال که دسترسی‌شون از طریق «کتابخانه من» هست.{" "}
                  <span>برای دسترسی راحت‌تر</span> در گوشی‌های اندروید می‌تونید
                  از اپلیکیشن آتروپین استفاده کنید و در گوشی‌های ios همین صفحه
                  رو add to homescreen کنید.
                </p>
              </div>
              <div className=" my-2 col-12 col-sm-6 col-md-6 col-lg-4">
                <button
                  onClick={() => navigate("/favoriteFlash")}
                  className="btn btn-primary btn-sm w-100 py-2"
                >
                  <span> جعبه من </span>
                  <FavoriteBoxIcon />
                </button>
              </div>
              <div className="flashCards-goto-box my-2 col-12 col-sm-6 col-md-6 col-lg-4">
                <article className="input-group " style={{ direction: "ltr" }}>
                  <button
                    className="btn btn-outline-primary"
                    type="button"
                    id="button-addon1"
                    onClick={handleSearch}
                  >
                    برو به
                  </button>
                  <input
                    value={searchIndex === 0 ? null : searchIndex}
                    // onChange={(e) => setSearchIndex(Number(e.target.value))}
                    onChange={(e) => setSearchIndex(+e.target.value)}
                    type="number"
                    aria-label="Example text with button addon"
                    aria-describedby="button-addon1"
                    className="form-control text-end"
                    placeholder="برو به فلش کارت"
                  />
                </article>
              </div>
            </div>
          )}
          {/* --------------------- لیست دسته بندی فلش کارت ها -------------------- */}
          {flashId == 4 && (
            <>
              <p>فیلتر دسته بندی فلش کارت:</p>
              <ul className="row w-100 d-flex">
                {subCategory.length &&
                  subCategory.categoryID === 4 &&
                  subCategory.map((item, index) => (
                    <li
                      key={index}
                      className="col-6 col-sm-4 col-md:3 col-lg-2 mb-2 mb-md-4 text-md-center"
                    >
                      <button
                        onClick={() => {
                          callNewProducts(item.id);
                          setActiveFlash(item.id);
                        }}
                        style={{ backgroundColor: "#273c75" }}
                        className={`${
                          activeFlash === item.id
                            ? "border shadow-sm"
                            : "border-none"
                        } px-4 rounded-md btn btn-sm text-white`}
                      >
                        {item.subCategoryTitle}
                      </button>
                    </li>
                  ))}
              </ul>
            </>
          )}
          {/* ------------------------------------------------------------------- */}
          <div className="row flex-column-reverse flex-lg-row">
            <div className="col-lg-9 col-md-12 order-1 order-md-1 order-sm-1">
              <div className="row shop_wrapper px-5">
                {/* --------- search flash cart ---------------- */}
                {/* && activeFlash !== 0 */}
                {productsBySubCategory &&
                  flashId !== 4 &&
                  productsBySubCategory
                    ?.sort((a, b) => a.olaviyat - b.olaviyat)
                    ?.filter((item) => item.isAsli)
                    ?.map((item, index) =>
                      flashId == 3 && item.isSite === true ? (
                        <div key={index} className="col-lg-4 col-md-4 col-sm-6">
                          <ProductOne item={item} hover={false} />
                        </div>
                      ) : (
                        flashId !== 4 &&
                        item.isSite === true && (
                          <div
                            key={index}
                            className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-sm-12"
                          >
                            <ProductOne
                              item={item}
                              hover={
                                item.type === "audio" || item.type === "video"
                                  ? false
                                  : true
                              }
                            />
                          </div>
                        )
                      )
                    )}

                {/* flash content */}
                {flashId == 4 && (
                  <div className="flashCards-goto-box mobile-size mt-5 ">
                    <article
                      className="input-group "
                      style={{ direction: "ltr" }}
                    >
                      <button
                        className="btn btn-outline-primary"
                        type="button"
                        id="button-addon1"
                        onClick={handleSearch}
                      >
                        برو به
                      </button>
                      <input
                        value={searchIndex === 0 ? null : searchIndex}
                        // onChange={(e) => setSearchIndex(Number(e.target.value))}
                        onChange={(e) => setSearchIndex(+e.target.value)}
                        type="number"
                        aria-label="Example text with button addon"
                        aria-describedby="button-addon1"
                        className="form-control text-end"
                        placeholder="برو به فلش کارت"
                      />
                    </article>
                  </div>
                )}

                {productsBySubCategory &&
                  Object.assign([], productsBySubCategory)
                    .sort((a, b) => a.olaviyat - b.olaviyat)
                    .map((item, index) =>
                      item.isSite === true && flashId == 4 ? (
                        (
                          paymentedCheck(
                            existProduct,
                            productsBySubCategory[0]?.subCategoryID
                          )
                            ? index < productsBySubCategory.length
                            : index < 5 && activeFlash !== 0
                        ) ? (
                          <div
                            key={index}
                            className="col-lg-4 col-md-6 col-sm-12 mb-5"
                          >
                            <Flash
                              onClick={(e) =>
                                modalFlashShowingHandler(e, index)
                              }
                              item={item}
                              index={index}
                              flashId={flashId}
                            />
                          </div>
                        ) : (
                          activeFlash !== 0 && (
                            <>
                              <div
                                key={index}
                                className="col-lg-4 col-md-6 col-sm-12 mt-4"
                              >
                                <article
                                  className="single_product"
                                  style={{ padding: 0, border: 0 }}
                                >
                                  <figure>
                                    <div className="deck">
                                      <div id={item.id} className="card">
                                        <div
                                          className="front face flash-card"
                                          style={{ position: "relative" }}
                                        >
                                          <i
                                            className="fa fa-lock"
                                            style={{
                                              fontSize: "40px",
                                              color: "white",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              height: "100%",
                                            }}
                                          ></i>
                                          <p className="flash-card-footer">
                                            {index}. {item.title}
                                          </p>

                                          {/* <button
                                            type="button"
                                            className="flashCard-addTo-btn"
                                            style={{
                                              position: "absolute",
                                              color: "blue",
                                              zIndex: 99999,
                                              top: 5,
                                              left: 5,
                                            }}
                                            onClick={(e) =>
                                              addToSabadKharidHandler(e, item)
                                            }
                                          >
                                            افزودن به سبد خرید
                                          </button> */}
                                        </div>
                                      </div>
                                    </div>
                                  </figure>
                                </article>
                              </div>
                              {/* in mobile mode of flash cards categories will be under the flash cards */}
                            </>
                          )
                        )
                      ) : null
                    )}

                {flashId == 4 && (
                  <div className="widget_list widget_categories show-in-mobile mt-5">
                    <h2>دسته بندی</h2>

                    <ul>
                      {category &&
                        category?.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              setFlashId(item.id);
                              callNewProducts(item.id);
                              callNewCategories(item.id, products);
                              scrollTo({
                                top: 0,
                                behavior: "smooth",
                              });
                            }}
                          >
                            <Link
                              target={item.id === 10 ? "_blank" : "_self"}
                              to={
                                item.id === 10
                                  ? "/consultation"
                                  : item.id === 13 ? `/shop?catId=${item.id}&maghta=op` :`/shop?catId=${item.id}`
                              }
                            >
                              {item.categoryTitle}
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div className="col-lg-3 col-md-12 order-2 order-md-2 order-sm-2">
              <aside className="sidebar_widget">
                <div className="widget_inner">
                  {/* in mobile mode of flash cards categories will be under the flash cards */}
                  <div
                    className={
                      flashId == 4
                        ? "hide-forFlash-cards widget_list widget_categories "
                        : "widget_list widget_categories"
                    }
                  >
                    <h2>دسته بندی</h2>

                    <ul>
                      {category &&
                        category?.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => {
                              callNewCategories(item.id, products);
                              setFlashId(item.id);
                            }}
                          >
                            <Link
                              target={item.id === 10 ? "_blank" : "_self"}
                              to={
                                item.id === 10
                                  ? "/consultation"
                                  : item.id === 13 ? `/shop?catId=${item.id}&maghta=op` :`/shop?catId=${item.id}`
                              }
                            >
                              {item.categoryTitle}
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </div>

                  <div className="widget_list widget_categories  w-100">
                    <h2>زیر دسته بندی</h2>
                    <div
                      style={
                        categoryLoading
                          ? {
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              minHeight: 150,
                            }
                          : { display: "none" }
                      }
                    >
                      {categoryLoading ? (
                        <div class="loader-6 centerLoader">
                          <span></span>
                        </div>
                      ) : null}
                    </div>

                    <ul className="m-0 p-0">
                      {subCategory &&
                        productsBySubCategory &&
                        !categoryLoading &&
                        subCategory
                          ?.filter((item) =>
                            productsBySubCategory?.map((I) => I.subCategoryID)
                          )
                          ?.map((item, index) => (
                            <div
                              className="d-flex align-items-center justify-content-between my-1 w-100"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <li key={index}>
                                <Link
                                  className="btn subCategory_filter"
                                  to={
                                    item.categoryID === 13
                                      ? `/shop?catId=${item.categoryID}&subCatId=${item.id}&maghta=op`
                                      : `/shop?catId=${item.categoryID}&subCatId=${item.id}`
                                  }
                                  onClick={() => {
                                    callNewProducts(item.id);
                                    setFlashId(item.categoryID);
                                  }}
                                  style={{
                                    minWidth: 183,
                                  }}
                                >
                                  {item.subCategoryTitle}
                                </Link>
                              </li>
                              {!isUserPurchasedFlashCards(item) ? (
                                <>
                                  {flashId == 4 &&
                                    checkSubCategoryPrices(item)
                                      ?.totalPriceTakhfif > 0 && (
                                      <div className="subCategory-pricing d-flex flex-column align-items-center">
                                        {checkSubCategoryPrices(item)
                                          ?.totalPrice !==
                                          checkSubCategoryPrices(item)
                                            ?.totalPriceTakhfif && (
                                          <p className="price my-0">
                                            <span className="mr-1">
                                              {checkSubCategoryPrices(
                                                item
                                              )?.totalPrice?.toLocaleString()}
                                            </span>
                                            تومان
                                          </p>
                                        )}
                                        <p className="priceTakhfif my-0">
                                          <span className="mr-1">
                                            {checkSubCategoryPrices(
                                              item
                                            )?.totalPriceTakhfif?.toLocaleString()}
                                          </span>
                                          تومان
                                        </p>
                                      </div>
                                    )}
                                  <li>
                                    {checkSubCategoryPrices(item)?.filteredList
                                      ?.length > 0 ? (
                                      <button
                                        style={{
                                          // color: "white",
                                          textAlign: "center",
                                          justifyContent: "center",
                                        }}
                                        className="btn subCategory_addToCart btn-sm me-lg-2"
                                        onClick={(e) =>
                                          addToSabadKharidHandler(e, item)
                                        }
                                      >
                                        <span>افزودن به سبد</span>
                                      </button>
                                    ) : (
                                      <span>به زودی...</span>
                                    )}
                                  </li>
                                </>
                              ) : null}
                            </div>
                          ))}
                    </ul>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      {/*------------------------------------------- Modal--------------------------- */}
      {selectTypeCategory == 4 && (
        <div
          className="modal fade show"
          role="dialog"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.6)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content rounded w-75 mx-auto col-11 col-sm-8 col-md-6 col-lg-4">
              <div className="modal-header">
                <button
                  type="button"
                  className="close m-1 text-center"
                  onClick={() => {
                    setSelectTypeCategory(0);
                  }}
                >
                  <TimesIcon />
                </button>
                <h5 className="modal-title"> آتروپین</h5>
              </div>
              <div className="modal-body w-100 " style={{ minHeight: "150px" }}>
                <div className="modal-body text-center">
                  لطفاً زیر دسته بندی مورد نظر را انتخاب کنید
                </div>
                <div
                  style={
                    categoryLoading
                      ? {
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          minHeight: 100,
                        }
                      : { display: "none" }
                  }
                >
                  {categoryLoading ? (
                    <div class="loader-6 centerLoader">
                      <span></span>
                    </div>
                  ) : null}
                </div>
                <ul className="row list-group  list-group-flush">
                  {subCategory?.[0]?.categoryID === 4 &&
                    !categoryLoading &&
                    subCategory.map((item, index) => (
                      <li
                        key={index}
                        className=" list-group-item"
                        onClick={() => {
                          setFlashId(item.categoryID);
                          callNewProducts(item.id);
                          setActiveFlash(item.id);
                          // setStyles("none");
                          setSelectTypeCategory(false);
                        }}
                      >
                        <button
                          className={`${
                            activeFlash === item.id ? "border-2" : "border-none"
                          } btn btn-sm text-white w-100`}
                          style={{ backgroundColor: "#273c75" }}
                        >
                          {item.subCategoryTitle}
                        </button>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Shop;

// <div
// className={classes}
// id="exampleModal"
// tabindex="-1"
// role="dialog"
// aria-labelledby="exampleModalLabel"
// aria-hidden="true"
// style={{ display: styles }}
// >
// <div className="modal-dialog modal-dialog-centered" role="document">
//   <div className="modal-content rounded">
//     <div className="modal-header">
//       <h5 className="modal-title" id="exampleModalLabel">
//         آتروپین
//       </h5>
//     </div>
//     <div className="modal-body">لطفاً زیر دسته بندی مورد نظر را انتخاب کنید</div>
//     <ul className="row">
//       {subCategory &&
//         subCategory.map((item, index) => (
//           <li
//             key={index}
//             className=" col-md-4 my-2 my-md-4 text-md-center"
//             onClick={() => {
//               callNewProducts(item.id);
//               setActiveFlash(item.id);
//               setStyles("none");
//             }}
//           >
//             <button
//               style={{
//                 color: "white",
//                 textAlign: "center",
//                 justifyContent: "center",
//               }}
//               className={`${
//                 activeFlash === item.id ? "border-4 border-blue" : "border-none"
//               } btn btn-primary btn-sm mr-4 ml-4`}
//             >
//               {item.subCategoryTitle}
//             </button>
//           </li>
//         ))}
//     </ul>
//     {/* <div className="modal-footer">
//   <button
//     type="button"
//     onClick={() => setStyles("none")}
//     className="button outline-none border-none border-primary"
//   >
//     تأیید
//   </button>
// </div> */}
//   </div>
// </div>
// </div>
